<template>
  <div class="create_modal_form">
    <div v-if="!close && isCreateBot" class="create_modal">
      <div class="create_modal_text">
        Click to select links now and fine-tune your bot's learning after the
        scan.

        <img
          class="create_modal_x"
          src="@/assets/img/close_modal.svg"
          alt=""
          @click="closeModal"
        />
      </div>
    </div>
    <div v-if="isCreateBot" class="create_from">
      <!-- <sidebar-link class="create_hover" to="/user/chatbots">
        <img src="@/assets/img/icn_back.svg" alt="" />
      </sidebar-link> -->
      <div class="create_from_bc">Create new Chatbot</div>
      <div class="create_from_step">Step 1/2</div>

      <img src="@/assets/img/arrow_filling.svg" alt="" />
    </div>
    <!-- <div class="create_choose_bl">
      <div class="create_choose">Choose your data type:</div>

      <div class="create_bt_block">
        <button
          class="create_bt_desc"
          :class="{ 'create_bt_desc--active': botData.linkType === icon.text }"
          v-for="(icon, index) in icons"
          @click="setWebsiteType(icon.text)"
          :key="index"
        >
          <svg class="svg_icon">
            <use :xlink:href="`${icon.image}${icon.url}`"></use>
          </svg>
          <div class="create_icon">
            {{ icon.text }}
          </div>
        </button>
      </div>
    </div> -->
    <div class="create_url_desc">
      <div class="create_url">Website URL:</div>
      <form @submit.prevent="fetchLink" class="create_url_btn">
        <div>
          <CustomInputWithImg
            :placeholder="'Link'"
            @input="handleWebsiteUrlInput"
            :value="this.botData.websiteLink"
            :isError="websiteUrlInputError"
            :maxlength="maxLinkLength"
            errorMessage="`Max link length ${maxLinkLength}`"
            :hideImg="true"
          />
        </div>
        <ButtonWithLoadWebsite
          v-if="isCreateBot ? !links.length : (!links.length && !isSingleLink)"
          type="submit"
          class="create_btn_text"
          :title="buttonText"
          :isDisabled="fetchLinksDisabled || isLoading"
        >
          <svg v-show="isLoading" class="svg_icon_loader">
            <use
              class="rotate-svg"
              xlink:href="@/assets/img/Loader.svg#loader"
            ></use>
          </svg>
        </ButtonWithLoadWebsite>

        <ButtonWithLoadWebsite
          v-if="links.length"
          class="create_btn_text"
          :title="'Reset'"
          @onClick="reset"
        />
      </form>
    </div>
    <div v-show="isLoading" class="fetching">
      <div class="fetching_load">
        <img class="rotate-svg" src="@/assets/img/Loader_1.svg" alt="" />
        <div>Fetching Links...</div>
      </div>
    </div>
    <div v-show="links.length > 0">
      <div class="links_cont">
        <div class="links_found">
          {{ links.length }} links found

          <span v-if="selectedLinks.length"
            >{{ selectedLinks.length }} links selected
          </span>
        </div>

        <CustomInputWithImg
          placeholder="Search URL"
          v-model="substring"
          @input="handleVisibleLinks(firstLinksPage)"
        />
      </div>

      <div class="pagination_box">
        <Pagination
          @updateVisibleData="handleVisibleLinks"
          :allDataLength="filteredLinks.length"
        />
      </div>

      <p v-if="!filteredLinks.length" class="not-found-message">
        Links for query <b>"{{ substring }}"</b> not found!
      </p>

      <div
        v-if="filteredLinks.length || linksTotalPages > 1"
        class="pagination-btns-box"
      >
        <div v-if="selectedLinks.length" class="selection-actions">
          <div class="input_select_cont only-selected-checkbox">
            <input
              type="checkbox"
              id="onlySelected"
              value=""
              v-model="onlySelected"
              @change="handleVisibleLinks(firstLinksPage)"
            />
            <label class="input_select" for="onlySelected"
              >Filter selected</label
            >
          </div>

          <ButtonWithLoadWebsite
            @onClick="deselectAll"
            class="create_btn_text"
            :title="'Reset selection'"
            :isDisabled="!selectedLinks.length"
          />
        </div>
      </div>

      <div v-if="filteredLinks.length" class="input_select_cont">
        <input
          type="checkbox"
          id="selectAll"
          value=""
          v-model="selectAllChecked"
          @change="selectAllChanged"
        />
        <label class="input_select" for="selectAll">Select all</label>
      </div>

      <div :class="['links_wrapper', isCreateBot ? '' : 'links_page']">
        <div
          v-for="(link, index) of visibleLinks"
          :key="index"
          class="input_select_links_cont"
        >
          <input
            type="checkbox"
            :id="'link' + index"
            :value="link"
            v-model="selectedLinks"
            @change="linkCheckboxChanged"
          />
          <label :for="'link' + index" class="input_select_links">{{
            link
          }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import InputWebsiteVue from "../../components/shared/InputWebsite.vue";
import Pagination from "../../components/shared/Table/Pagination.vue";
import CustomInputWithImg from "../../components/shared/UI/CustomInputWithImg.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

import { PER_PAGE } from "../../components/shared/Table/Pagination.vue";

export default {
  components: {
    InputWebsiteVue,
    ButtonWithLoadWebsite,
    CustomInputWithImg,
    Pagination,
  },
  props: {
    isCreateBot: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      icons: [
        {
          image: require("@/assets/img/Icons_tv.svg"),
          text: "Website",
          url: "#facebook",
        },
        {
          image: require("@/assets/img/pin_icon.svg"),
          text: "Single link",
          url: "#facebook",
        },
        {
          image: require("@/assets/img/direction_icon.svg"),
          text: "Site map",
          url: "#facebook",
        },
        // {
        //   image: require("@/assets/img/zende_icon.svg"),
        //   text: "Zendesk",
        //   url: "#facebook",
        // },
        // {
        //   image: require("@/assets/img/book_icon.svg"),
        //   text: "Gitbook",
        //   url: "#facebook",
        // },
      ],
      placeholder: "Search URL",
      close: true,
      close_icon: true,
      links: [],
      linksSkip: 0,
      linksLength: PER_PAGE,
      selectAllChecked: false,
      onlySelected: false,
      selectedLinks: [],
      substring: "",
      botData: {
        websiteLink: "",
        links: [],
        linkType: "Website",
      },
      firstLinksPage: { skip: 0, length: PER_PAGE },
      maxLinkLength: 350,
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    linksPerPage() {
      return PER_PAGE;
    },
    buttonText() {
      return this.isLoading ? "Fetching" : "Fetch link";
    },
    websiteUrlInputError() {
      return this.botData.websiteLink.length === this.maxLinkLength;
    },
    isSingleLink() {
      return this.botData.linkType === 'Single link';
    },
    filteredLinks() {
      const links = this.onlySelected ? this.selectedLinks : this.links;

      return this.substring === ""
        ? links
        : links.filter((link) => {
            if (!link) {
              return;
            }
            return link.includes(this.substring);
          });
    },
    fetchLinksDisabled() {
      const isLinkTypeChecked = this.botData.linkType === "" ? false : true;
      const isValidUrl = this.isValidURL(this.botData.websiteLink);
      return isLinkTypeChecked && isValidUrl ? false : true;
    },

    linksTotalPages() {
      if (this.onlySelected) {
        if (!this.selectedLinks.length) return;
        return Math.ceil(this.selectedLinks.length / this.linksPerPage);
      }

      if (!this.filteredLinks.length) return;
      return Math.ceil(this.filteredLinks.length / this.linksPerPage);
    },
    visibleLinks() {
      if (!this.filteredLinks.length) return;

      return this.filteredLinks.slice(this.linksSkip, this.linksLength);
    },
  },
  async mounted() {
    if (localStorage.botData) {
      this.botData = JSON.parse(localStorage.getItem("botData"));

      const websiteLink = this.botData.websiteLink;

      try {
        if (websiteLink && !this.fetchLinksDisabled) {
          const links = await this.fetchLink(websiteLink);

          if (links) {
            this.links = links;
          }
        }
      } catch (error) {
        console.log(
          "🚀 ~ file: CreateBotForm.vue:314 ~ mounted ~ error:",
          error
        );

        this.$toast.error("Link fetching error");
      }
    }

    if (localStorage.botDataSelectedLinks) {
      this.selectedLinks = JSON.parse(
        localStorage.getItem("botDataSelectedLinks")
      );
    }
  },
  watch: {
    selectedLinks: {
      handler: function () {
        this.botData.links = this.selectedLinks;
        localStorage.setItem(
          "botDataSelectedLinks",
          JSON.stringify(this.selectedLinks)
        );
      },
    },
    botData: {
      deep: true,
      handler: function () {
        store.dispatch("updateCreateBotData", this.botData);
        localStorage.setItem("botData", JSON.stringify(this.botData));
      },
    },
  },
  methods: {
    checkWebsiteUrl(url) {
      const https = "https://";
      return url === https ? "" : url.startsWith(https) ? url : https + url;
    },
    setWebsiteType(type) {
      this.botData.linkType = type;
      this.links = [];
      this.selectedLinks = [];
      this.substring = "";
    },
    handleWebsiteUrlInput(url) {
      if (this.links.length > 0) {
        this.links = [];
      }

      if (this.selectedLinks.length > 0) {
        this.selectedLinks = [];
      }

      this.botData.websiteLink = this.checkWebsiteUrl(url);
    },
    updateBotDataField({ key, value }) {
      this.botData[key] = value;
    },
    async fetchLink() {
      try {
        if (this.botData.linkType === 'Single link' && !this.isCreateBot) return;

        store.dispatch("startLoading");

        const response = await DataService.post(
          `${API_ENDPOINT}widget/getLinks`,
          {
            link: this.botData.websiteLink,
            type: this.botData.linkType,
          }
        );

        if (
          !response?.data ||
          !response?.data.length ||
          response?.data.length === 0
        ) {
          this.$toast.error(`Links not found, try search with "Single link"`);
        }

        if (response?.data.length > 0) {
          this.links = response?.data;
          store.dispatch("updateCreateBotData", { websiteLink: this.url });
        }
      } catch (error) {
        console.log(
          "🚀 ~ file: CreateBotForm.vue:328 ~ fetchLink ~ error:",
          error
        );
        this.$toast.error(
          error?.response?.data?.errorDescription || "Fetch link error"
        );
      } finally {
        store.dispatch("endLoading");
        gtag('event', 'create_bot_parsing_initiate_scan_started', {});
        amplitude.getInstance().logEvent('create_bot_parsing_initiate_scan_started', {});
      }
    },
    reset() {
      this.links = [];
      this.selectedLinks = [];
      this.botData.websiteLink = "";
      this.substring = "";
      this.linksPage = 1;
      const botDataKeys = ["botData", "botDataSelectedLinks", "botSettings"];
      botDataKeys.forEach((value) => localStorage.removeItem(value));
    },
    handleVisibleLinks({ skip, length }) {
      this.linksSkip = skip;
      this.linksLength = length;
    },
    deselectAll() {
      this.selectAllChecked = false;
      this.selectedLinks = [];
      this.handleVisibleLinks(this.firstLinksPage);
      this.onlySelected = false;
      store.dispatch("updateCreateBotData", { links: this.selectedLinks });
      gtag('event', 'create_bot_parsing_select_reset_click', {});
      amplitude.getInstance().logEvent('create_bot_parsing_select_reset_click', {});
    },
    selectAllChanged() {
      if (this.selectAllChecked) {
        this.selectedLinks = [...this.links];
        gtag('event', 'create_bot_parsing_select_all_click', {});
        amplitude.getInstance().logEvent('create_bot_parsing_select_all_click', {});
      } else {
        this.selectedLinks = [];
      }

      store.dispatch("updateCreateBotData", { links: this.selectedLinks });
    },
    linkCheckboxChanged() {
      this.selectAllChecked = this.selectedLinks.length === this.links.length;
      store.dispatch("updateCreateBotData", { links: this.selectedLinks });
    },
    closeModal() {
      this.close = false;
    },
    closeX() {
      this.close_icon = false;
    },
    isValidURL(url) {
      const urlPattern =
        /^((http|https):\/\/)?(www\.)?([A-Za-z0-9]{1}[A-Za-z0-9\-]*\.?)*\.{1}[A-Za-z0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

      return urlPattern.test(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination-btns-box {
  display: flex;
  align-items: center;
  gap: 16px;
}

.create_from {
  display: flex;
  gap: 16px;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
.rotate-svg {
  animation: rotate 4s linear infinite;
  transform-origin: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.create_from_bc {
  color: #212b36;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
}
.create_from_step {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
}
.create_choose {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
}
.create_hover:hover {
  background: none !important;
}
.create_bt_block {
  display: flex;
  gap: 16px;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}
.create_img {
  width: 16px;
}
.create_bt_desc {
  border-radius: 6px;
  border: 1px solid #c4c4c4;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: none;

  @media screen and (max-width: 768px) {
    padding: 8px 16px;
  }

  .create_icon {
    color: #c4c4c4;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  .svg_icon {
    fill: #c4c4c4;
  }
}
.create_bt_desc--active {
  border: 1px solid #3056d3;

  .create_icon {
    color: #3056d3;
  }

  .svg_icon {
    fill: #3056d3;
  }
}
.create_icon {
  color: #c4c4c4;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.create_url {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
}

.create_choose_bl {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 51px;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}

.create_url_desc {
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
}
.create_url_btn {
  display: flex;
  gap: 16px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    & > button {
      max-width: 160px;
    }
  }
}
.not-found-message {
  display: block;
  width: 100%;
  margin: 48px 0 32px;
  padding: 0;
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-overflow: ellipsis;
  word-wrap: break-word;

  & > b {
    color: #4f4f4f;
  }
}

.links_found {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: flex;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }

  & > span {
    margin-left: 16px;
  }
}
.create_modal_x_ {
  cursor: pointer;
}
.input_select {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.17px;

  &:hover {
    cursor: pointer;
  }
}
.input_select_links {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.17px;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: pointer;
  }
}
.create_btn_text {
  color: #f8fafc;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.pages-count {
  display: flex;
  flex-basis: 80px;
  align-items: center;
  justify-content: center;
}

.link_desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.links_cont {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (max-width: 768px) {
    justify-content: center;
    text-align: center;
  }
}
.create_modal_x {
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: pointer;
}
.links_modal {
  color: #27ae60;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px dashed #27ae60;
  background: #fff;
  line-height: 24px;
  padding: 6px 0px 6px 16px;
}
.fetching {
  max-width: 788px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #d1d1d6;
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.17px;
  padding: 8px 0 8px 20px;
}
.svg_icon {
  fill: #c4c4c4;
}
.svg_icon_loader {
  width: 30px;
  height: 30px;
  fill: #f8fafc;
}

.create_btn_text:hover .svg_icon_loader {
  fill: #3056d3 !important;
}
.create_modal {
  max-width: 645px;
  width: 100%;
  height: 92px;
  color: #27ae60;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  border-radius: 8px;
  border: 1px dashed #27ae60;
  background: #fff;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fetching_load {
  display: flex;
  gap: 12px;
  align-items: center;
}
.create_modal_form {
  max-width: 788px;
  width: 100%;
}
.input_select_cont {
  display: flex;
  gap: 12px;
  margin: 16px 0;

  input:hover {
    cursor: pointer;
  }
}

.only-selected-checkbox {
  margin: 0;
}

.links_wrapper.links_page {
  max-height: 168px;
  overflow: auto;
}

.input_select_links_cont {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #ededed;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: 420px) {
    max-width: 250px;
  }

  &:last-child {
    margin-bottom: 32px;
  }
}

.selection-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 32px 0 0;
}

.pagination_box {
  display: flex;
  margin-top: 32px;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}
</style>
